import React from 'react';
import './AttendeesRow.scss';

/**
 * @param {{ id: string; imageUrl?: string; alt: string }[]} attendees
 * @param {string} countLabel
 */
const AttendeesRow = ({ attendees, countLabel, showCount, showProfiles, hide, finish }) => {
  if(hide) return null;
  // If attendees not loaded yet, show skeletons only
  const hasAttendees = finish;
  if (!hasAttendees) {
    return (
      <div className="attendees-row">
        <div className="avatars">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} className="avatar-skeleton-row" />
          ))}
        </div>
        <span className="count-label skeleton-label" />
      </div>
    );
  }
  if (!attendees || attendees.length === 0) {
    return (
      <div className="attendees-row">
        {showCount && <span className="count-label">{countLabel}</span>}
      </div>
    );
  }
  // Find center index: priority to a valid imageUrl
  const validIndex = attendees.findIndex(
    (u) => u.imageUrl && u.imageUrl.trim() !== ''
  );
  const centerIndex =
    validIndex >= 0 ? validIndex : Math.floor(attendees.length / 2);

  // Determine slice window of 5 attendees around center
  const total = attendees.length;
  let start = centerIndex - 2;
  if (start < 0) start = 0;
  let end = start + 5;
  if (end > total) {
    end = total;
    start = Math.max(0, total - 5);
  }
  const slice = attendees.slice(start, end);

  // Generate a consistent color per user ID
  const getRandomColor = (id) => {
    let hash = 0;
    for (let char of id) {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 50%)`;
  };

  // Get initial letter from alt (assumed name)
  const getInitial = (alt) => (alt ? alt.charAt(0).toUpperCase() : '');

  return (
    <div className="attendees-row">
    {showProfiles &&  <div className="avatars">
        {slice.map((user, idx) => {
          const hasImage = user.imageUrl && user.imageUrl.trim() !== '';
          return hasImage ? (
            <img
              key={user.uid}
              src={user.imageUrl}
              alt={user.name}
              className="avatar"
              style={{ zIndex: total - idx }}
            />
          ) : (
            <div
              key={user.id}
              className="guest-avatar"
              style={{ backgroundColor: getRandomColor(user.uid), zIndex: total - idx }}
            >
              <span className="initial">{getInitial(user.name)}</span>
            </div>
          );
        })}
      </div>}
     {showCount && <span className="count-label">{countLabel}</span>}
    </div>
  );
};

export default AttendeesRow;
